import { reactive } from "vue";
import axios from "axios";

export const state = reactive({
  user: {
    firstname: "",
    name: "",
    birthday: "",
    birthplace: "",
    email: "",
    tel: "",
    addressLine1: "",
    addressLine2: "",
    state: "",
    city: "",
    country: "",
    zipcode: "",
  },
  activity: {
    isEmployee: true,
    legalStatus: "",
    siret: "",
    apeCode: "",
    businessCreation: "",
    files: [],
  },
  formation: {
    certification: "",
    school: "fzefzef",
    gotDegrees: false,
    precision: "",
    files: [],
  },
  motivations: "",
  toast: {
    show: false,
    message: "",
  },
  postSuccess: false,
  respMsg: "",
});

export const wpApiSettings = window.wpApiSettings || {
  root: "http://localhost/wordpress/wp-json/",
  url: "http://localhost/wordpress/",
  dev: true,
};

console.log(wpApiSettings);

export const baseUrl = `${wpApiSettings.root}api/v1`;

axios.interceptors.request.use((config) => {
  if (wpApiSettings.nonce) {
    config.headers["X-WP-Nonce"] = wpApiSettings.nonce;
  }
  return config;
});

export async function send() {
  const data = {
    user: state.user,
    activity: state.activity,
    formation: state.formation,
    motivations: state.motivations,
  };

  let formData = new FormData();

  Object.keys(data).forEach((key) => {
    if (typeof state[key] !== "object") {
      formData.append(key, state[key]);
    } else {
      formData.append(key, JSON.stringify(state[key]));
    }
  });

  state.activity.files.forEach((file) => {
    formData.append(`Situation (indépendant, salarié) - ${file.name}`, file);
  });

  state.formation.files.forEach((file) => {
    formData.append(`Certifications praticien - ${file.name}`, file);
  });

  await axios({
    method: "POST",
    url: `${baseUrl}/adhesion?pro=true`,
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
  })
    .then((res) => {
      state.postSuccess = true;
      state.respMsg = res.data;
    })
    .catch((err) => {
      console.log(err);
      showToast(err.response.data?.data);
    });
}

function showToast(message) {
  state.toast.show = true;
  state.toast.message = message;

  setTimeout(() => (state.toast.show = false), 3000);
}
